import { Type } from '@angular/core';
import { BaseController } from './BaseController';
import { BaseViewAnimationTrait } from './BaseViewAnimationTrait';
import { BaseViewPopoverTrait } from './BaseViewPopoverTrait';
import { BaseViewComponentTrait } from './BaseViewComponentTrait';
import { RailgunBase } from 'src/app/RailgunBase';
import { AppViewReceiverUtil } from 'src/app/Util/AppReceiver/AppViewReceiverUtil';
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { LogService } from "../../../Service/LogService";



/**
 * BaseView
 *
 * Viewの基底クラス
 */
export abstract class BaseView
extends BaseViewComponentTrait(BaseViewPopoverTrait(BaseViewAnimationTrait(RailgunBase))) {
// BaseViewが大きすぎるので、機能分割して、各Traitに移設。

	// 対応するコントローラー
	// 継承先のコンポーネントでオーバーライドされる
	public combineCtrl: any;

	// イベント設定用の配列
	protected EVENT_LIST: Array<Array<any>> = [[]];

	/**
	 * 初期化処理
	 */
	constructor() {
		super();
	}

	/**
	 * registerEvent
	 * イベントを登録する。登録しないと、receiver経由で呼ばれない。
	 * EVENT_LIST をオーバライドして、これを呼ぶ事。
	 */
	public registerEvent() {
		// 定義に書いたイベントを登録する。
		AppViewReceiverUtil.setEventProcList(this.EVENT_LIST);
	}

	/**
	 * start
	 * 開始処理 必ず実装する必要あり
	 */
	public abstract start(): void;

	/**
	 * createController
	 * 対応するコントローラの生成
	 * 特化コントローラーのインスタンスを生成し、そのコントローラーのプロパティに自分（View）のインスタンスを設定する
	 * @param controllerClass BaseControllerを継承したコントローラー
	 */
	public createController(controllerClass: Type<BaseController>) {

		// 渡されたクラス名でコントローラーのインスタンスを生成する
		this.combineCtrl = new controllerClass();

		// 生成したコントローラーのプロパティに自分（View）のインスタンスを設定する
		this.combineCtrl.combineView = this;

	}

	/**
	 * getTargetFormData
	 *
	 * 指定されたid でElementを取得。Formにキャスとしてデータだけ取り出して返してくれる。
	 * ※可能であればバインディングですます方がいい
	 *
	 * ※注意※
	 * checkbox/radio などは、チェックされたやつだけが、プロパティになって入ってくる。
	 * チェックされてないと、プロパティが undefined になる。
	 * チェックされた時は、値はHTML上の value に指定した値が入ってる。
	 * 		<input name="radioName" type="radio" placeholder="radioPH" value="No-1">
	 * 		<input name="radioName" type="radio" placeholder="radioPH" value="2ban">
	 * 		<input name="radioName" type="radio" placeholder="radioPH" value="three">
	 * 上記の様にグルーピングされたradioの場合は、２つ目がチェックされると、dataObj.radioName=2ban ってカンジで入ってくる。
	 * (グルーピングするradioは、name を共通にすればいい)
	 * １つもチェックされなければ、dataObj.radioName は、undefined。
	 * プロパティの存在チェックでどれがチェックされたか判定できる
	 * 		if ( dataObj.radioName ) { data = dataObj.radioName; }
	 * なので、上記の様にすれば、存在した時に、何番が選ばれたかを取得できる。
	 * 		<input name="checkbox11" type="checkbox" placeholder="checkbox" value="checkbox">
	 * チェックボックスは、チェックされるとプロパティが生えるので存在チェックだけでいける
	 * 		if ( dataObj.checkbox11 ) { checkbox11Boolean = true; }
	 *
	 * @param formId 取得したいId
	 * @param isJsonString 省略可。Jsonで欲しければtrue。
	 * @returns 取得したFormデータのKye/ValueのObj
	 */
	public getTargetFormData(formId: string, isJsonString = false): any {

		// Form をIDで取得
		const form = document.getElementById(formId) as HTMLFormElement;
		const fd = new FormData(form);

		// 必要なデータをObjに変換
		const dataObj = {}; // Array でなく、Objで作っておく。でないとJSON.stringifyでStringにならない。
		fd.forEach((item, key) => {
			this.log(item+':'+key);
			dataObj[key] = item;
		});

		// Jsonで欲しいときはjsonで返す。いらなければ削除
		if (isJsonString) {
			return JSON.stringify(dataObj);
		}

		return dataObj;


	}


	/**
	 * disablePhoneSwipeBack
	 * スワイプでロケーションバックされるのを防ぐ。
	 */
	public disablePhoneSwipeBack() {
		// スワイプでのロケーションバックを停止させる
		const element = document.querySelector('.block-swipe-nav');
		element.addEventListener('touchstart', (e: any) => {

			let pageX = 0;
			if (e.constructor.name === 'TouchEvent') {
				pageX = e.changedTouches[0].pageX;
			} else {
				if ('pageX' in e) {
					pageX = e.pageX;
				} else {
					// pageXが取得できない場合、動作が止まるのを防ぐため処理抜ける
					return;
				}
			}

			// is not near edge of view, exit
			if (pageX > 24 && pageX < window.innerWidth - 24) { return; }
			// prevent swipe to navigate gesture
			e.preventDefault();
		});
	}


	public async sendFingerprintLog(view: string, action: string) {
		const fpPromise = await FingerprintJS.load();
		fpPromise.get().then(val => {
			console.log(val);
			const svc = new LogService(this);
			svc.save(val.components.platform.value, val.visitorId, view, action);
		});
	}



}
